import React from 'react'
import Box from '@mui/material/Box'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'

type Props = {
  children: React.ReactNode
  isOpen?: boolean
  toggleOpen?: () => void
}

const AccordionTrigger = ({ children, isOpen = false, toggleOpen }: Props) => {
  const handleToggleOpen = () => {
    if (toggleOpen) {
      toggleOpen()
    }
  }

  return (
    <Box onClick={handleToggleOpen} sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2, cursor: 'pointer' }}>
      <ChevronRightIcon
        sx={{
          transform: `rotate(${isOpen ? '90deg' : '0deg'})`,
          transition: 'transform .1s ease-in-out'
        }}
      />
      {children}
    </Box>
  )
}

export default AccordionTrigger
